import { useQuery } from "@tanstack/react-query";
import { SystemIndicesRotation, SystemIndicesRetention } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const QUERY_KEY_ROTATION = ["system", "indices", "rotation", "strategies"];
const QUERY_KEY_RETENTION = ["system", "indices", "retention", "strategies"];
const useIndicesConfiguration = ({ enabled = true } = {}) => {
  const { data: rotationData, isInitialLoading: isLoadingRotation } = useQuery({
    queryKey: QUERY_KEY_ROTATION,
    queryFn: () => defaultOnError(
      SystemIndicesRotation.list(),
      "Fetching rotation strategies failed",
      "Could not retrieve rotation strategies"
    ),
    enabled
  });
  const { data: retentionData, isInitialLoading: isLoadingRetention } = useQuery({
    queryKey: QUERY_KEY_RETENTION,
    queryFn: () => defaultOnError(
      SystemIndicesRetention.list(),
      "Fetching retention strategies failed",
      "Could not retrieve retention strategies"
    ),
    enabled
  });
  return {
    rotationStrategies: rotationData == null ? void 0 : rotationData.strategies,
    retentionStrategies: retentionData == null ? void 0 : retentionData.strategies,
    retentionStrategiesContext: retentionData == null ? void 0 : retentionData.context,
    rotationStrategiesContext: rotationData == null ? void 0 : rotationData.context,
    isLoading: isLoadingRotation || isLoadingRetention
  };
};
export default useIndicesConfiguration;
